import React from 'react';
import PropTypes from 'prop-types';

import {
    Button,
    ButtonGroup,
    FormHelp,
    Label,
    Spacer,
    Textarea,
} from '@zillow/constellation';

import ErrorMessageConstants from 'app/shared/constants/ErrorMessageConstants';

const MODES = {
    CREATE: 'create',
    EDIT: 'edit',
};

const propTypes = {
    initialMessage: PropTypes.string,
    onDelete: PropTypes.func,
    onSubmit: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    mode: PropTypes.oneOf([MODES.CREATE, MODES.EDIT]),
};

const defaultProps = {
    initialMessage: '',
    onDelete: () => {},
    mode: MODES.CREATE,
};

class EditReviewResponse extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isSubmitting: false,
            errMessage: '',
            value: props.initialMessage,
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
    }

    handleChange(e) {
        this.setState({
            value: e.target.value,
            errMessage: '',
        });
    }

    handleSubmit() {
        this.setState({
            isSubmitting: true,
        });

        this.props.onSubmit(this.state.value)
            .catch(() => {
                this.setState({
                    isSubmitting: false,
                    errMessage: ErrorMessageConstants.DEFAULT_ERROR,
                });
            });
    }

    handleDelete() {
        // eslint-disable-next-line no-alert
        if (confirm('Do you want to delete this response?')) {
            this.setState({
                isSubmitting: true,
            });

            this.props.onDelete()
                .catch(() => {
                    this.setState({
                        isSubmitting: false,
                        errMessage: ErrorMessageConstants.DEFAULT_ERROR,
                    });
                });
        }
    }

    render() {
        const { mode } = this.props;
        const { isSubmitting, errMessage, value } = this.state;

        return (
            <div>
                <Label>Response to the above review</Label>
                <Textarea
                    disabled={isSubmitting}
                    error={!!errMessage}
                    placeholder="Type your response here"
                    value={value}
                    onChange={this.handleChange}
                />
                {errMessage && <FormHelp error={true}>{errMessage}</FormHelp>}
                <Spacer paddingTop="sm">
                    <ButtonGroup>
                        <Button
                            buttonType="primary"
                            onClick={this.handleSubmit}
                            disabled={value === '' || isSubmitting || errMessage !== ''}
                        >
                            {mode === MODES.CREATE ? 'Submit Response' : 'Update'}
                        </Button>
                        <Button
                            buttonType="secondary"
                            onClick={this.props.onCancel}
                            disabled={isSubmitting}
                        >
                            Cancel
                        </Button>
                        {mode === MODES.EDIT && (
                            <Button
                                buttonType="secondary"
                                onClick={this.handleDelete}
                                disabled={isSubmitting}
                            >
                                Delete
                            </Button>
                        )}
                    </ButtonGroup>
                </Spacer>
            </div>
        );
    }
}

EditReviewResponse.propTypes = propTypes;
EditReviewResponse.defaultProps = defaultProps;

export default EditReviewResponse;
